import React from 'react';
import Util from '../Util';
import { browserHistory } from 'react-router';
import * as actions from '../redux/actions';
import _ from 'lodash';

class KioskUpdateStep1 extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleSelect(kvs) {
    const { dispatch } = this.props;
    dispatch(actions.setKVS(kvs));
  }

  handleUpdate() {
    browserHistory.push('/kiosk/update');
  }

  render() {
    let { onCancel, selectedHostInfoList, selectedKVS, kvsList } = this.props;

    let sortedList = kvsList.slice().sort((kvs1, kvs2) => {
      return Util.parseDate(kvs2.lastUpdated) - Util.parseDate(kvs1.lastUpdated);
    });
    return (
      <div>
        <h1>Update Selected - {selectedHostInfoList.length} Kiosks</h1>
        <p>
          You have selected {selectedHostInfoList.length} kiosks to be updated. Please select an
          upgrade version.
        </p>
        <div
          className=''
          style={{ marginBottom: 20, maxHeight: '500px', minWidth: 700, overflowY: 'scroll' }}
        >
          {sortedList.map((kvs) => {
            return (
              <div
                key={kvs.name}
                className={kvs.name === selectedKVS.name ? 'row kvs-selected-row' : 'row'}
                onClick={this.handleSelect.bind(this, kvs)}
              >
                <div className='' style={{ minWidth: 600 }}>
                  {kvs.name}
                  {kvs.name === selectedKVS.name && (
                    <div
                      style={{
                        fontSize: 12,
                        float: 'right',
                        fontWeight: 400,
                        display: 'inline-block',
                      }}
                    >
                      Last changed {kvs.lastUpdatedXAgo} by {kvs.updatedBy}
                    </div>
                  )}
                </div>
                {kvs.name === selectedKVS.name && (
                  <div className='pure-g kvs-info'>
                    <div className='pure-u-24-24'>reason: {kvs.reason}</div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>printapi</span>
                      <br />
                      <span className='kvs-version'>{kvs.printapi}</span>
                    </div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>payapi</span>
                      <br />
                      <span className='kvs-version'>{kvs.payapi}</span>
                    </div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>capui</span>
                      <br />
                      <span className='kvs-version'>{kvs.capui}</span>
                    </div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>kioskprobe</span>
                      <br />
                      <span className='kvs-version'>{kvs.kioskprobe}</span>
                    </div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>kskapi</span>
                      <br />
                      <span className='kvs-version'>{kvs.kskapi}</span>
                    </div>
                    <div className='pure-u-3-24'>
                      <span className='kvs-em'>cafeapi</span>
                      <br />
                      <span className='kvs-version'>{kvs.cafeapi}</span>
                    </div>
                    <div className='pure-u-2-24'>
                      <span className='kvs-em'>heatwave</span>
                      <br />
                      <span className='kvs-version'>{kvs.heatwave}</span>
                    </div>
                    <div className='pure-u-2-24'>
                      <span className='kvs-em'>linuxdash</span>
                      <br />
                      <span className='kvs-version'>{kvs.linuxdash}</span>
                    </div>
                    <div className='pure-u-2-24'>
                      <span className='kvs-em'>ciscoamp</span>
                      <br />
                      <span className='kvs-version'>{kvs.ciscoamp}</span>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className='modalFooter pure-g' style={{ textAlign: 'right' }}>
          <div className='pure-u-5-24'></div>
          <div className='pure-u-1-4'>
            <button className='pure-button button-regular button-aux' onClick={onCancel}>
              Cancel
            </button>
          </div>
          <div className='pure-u-1-24'></div>
          <div className='pure-u-1-2'>
            <button
              className='pure-button button-regular button-primary'
              onClick={this.handleUpdate}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default KioskUpdateStep1;



// WEBPACK FOOTER //
// ./src/components/KioskUpdateStep1.js